import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum ToolConfirmationStatus {
  CONFIRMED = "confirmed",
  PENDING = "pending",
  NOT_REQUIRED = "not_required",
}

const ToolConfirmationStatusSchema = createEnum(ToolConfirmationStatus, {
  enumName: "ToolConfirmationStatus",
});

const PendingToolSchema_ = z.object({
  // toolCallId that we need to resolve
  id: z.string(),
  // Name of the tool to execute
  toolName: z.string(),
  // Arguments passed to the tool call by the LLM
  args: z.json(),
  // Confirmation status for this tool call
  confirmed: ToolConfirmationStatusSchema.nullish(),
  // Confirmation data needed to execute the tool call
  confirmationData: z.json().nullish(),
  // Message to show user when asking for confirmation
  confirmationPrompt: z.string().nullish(),
});

export const PendingToolSchema: z.ZodType<PendingTool> = PendingToolSchema_;
export interface PendingTool extends z.infer<typeof PendingToolSchema_> {}
